var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _class2, _class3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import CatalogMemberTraits from "./CatalogMemberTraits";
import GetCapabilitiesTraits from "./GetCapabilitiesTraits";
import GroupTraits from "./GroupTraits";
import mixTraits from "../mixTraits";
import ModelTraits from "../ModelTraits";
import objectTrait from "../Decorators/objectTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import UrlTraits from "./UrlTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
import { traitClass } from "../Trait";
export let DomainSpecTraits = (_dec = primitiveTrait({
  type: "string",
  name: "Domain Property Name",
  description: "Domain Property Name."
}), _dec2 = primitiveTrait({
  type: "string",
  name: "Hierarchy Separator",
  description: "Hierarchy Separator."
}), _dec3 = primitiveTrait({
  type: "string",
  name: "Query Property Name",
  description: "Query Property Name."
}), _class = class DomainSpecTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "domainPropertyName", _descriptor, this);
    _initializerDefineProperty(this, "hierarchySeparator", _descriptor2, this);
    _initializerDefineProperty(this, "queryPropertyName", _descriptor3, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "domainPropertyName", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "hierarchySeparator", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "queryPropertyName", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
let CswCatalogGroupTraits = (_dec4 = traitClass({
  description: "Creates one catalog group from url that points to a csw service.\n  The url in the example supports CORS therefore do not use proxy. Using a proxy might not work.",
  example: {
    type: "csw-group",
    url: "http://oa-gis.csiro.au/geonetwork/srv/eng/csw",
    domainSpecification: {
      domainPropertyName: "awavea",
      hierarchySeparator: " | ",
      queryPropertyName: "subject"
    },
    name: "Marine Energy Context Layers",
    id: "some unique ID"
  }
}), _dec5 = primitiveTrait({
  type: "boolean",
  name: "Flatten",
  description: "True to flatten the layers into a single list; false to use the layer hierarchy."
}), _dec6 = objectTrait({
  type: DomainSpecTraits,
  name: "Domain Specification",
  description: "Domain Specification"
}), _dec7 = primitiveTrait({
  type: "boolean",
  name: "Include WMS",
  description: "True to allow WMS resources to be added to the catalog; otherwise, false."
}), _dec8 = primitiveTrait({
  type: "boolean",
  name: "Include KML",
  description: "True to allow KML resources to be added to the catalog; otherwise, false."
}), _dec9 = primitiveTrait({
  type: "boolean",
  name: "Include CSV",
  description: "True to allow CSV resources to be added to the catalog; otherwise, false."
}), _dec0 = primitiveTrait({
  type: "boolean",
  name: "Include ESRI Map Server",
  description: "True to allow ESRI Map resources to be added to the catalog; otherwise, false."
}), _dec1 = primitiveTrait({
  type: "boolean",
  name: "Include GeoJSON",
  description: "True to allow GeoJSON resources to be added to the catalog; otherwise, false"
}), _dec10 = primitiveTrait({
  type: "string",
  name: "WMS Resource Format",
  description: "Gets or sets a regular expression that, when it matches the protocol attribute of a URI element of a record, indicates that the URI is a WMS resource."
}), _dec11 = primitiveTrait({
  type: "string",
  name: "KML Resource Format",
  description: "Gets or sets a regular expression that, when it matches the protocol attribute of a URI element of a record, indicates that the resource is a KML resource."
}), _dec12 = primitiveTrait({
  type: "string",
  name: "CSV Resource Format",
  description: "Gets or sets a regular expression that, when it matches the protocol attribute of a URI element of a record, indicates that the URI is a CSV resource."
}), _dec13 = primitiveTrait({
  type: "string",
  name: "ESRI MapServer Resource Format",
  description: "Gets or sets a regular expression that, when it matches the protocol attribute of a URI element of a record, indicates that the URI is a Esri MapServer resource."
}), _dec14 = primitiveTrait({
  type: "string",
  name: "WMS Resource Format",
  description: "Gets or sets a regular expression that, when it matches the protocol attribute of a URI element of a record, indicates that the URI is a GeoJSON resource."
}), _dec15 = primitiveTrait({
  type: "string",
  name: "GetRecords Template",
  description: "Gets or sets the template XML string to POST to the CSW server to query for catalog items.  If this property is undefined,`lib/Models/CswGetRecordsTemplate.xml` is used.  The XML string should have a `{startPosition}` placeholder to be replaced with the next start position in order to allow incremental paging of results.."
}), _dec4(_class2 = (_class3 = class CswCatalogGroupTraits extends mixTraits(GetCapabilitiesTraits, GroupTraits, UrlTraits, CatalogMemberTraits, LegendOwnerTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "flatten", _descriptor4, this);
    _initializerDefineProperty(this, "domainSpecification", _descriptor5, this);
    _initializerDefineProperty(this, "includeWms", _descriptor6, this);
    _initializerDefineProperty(this, "includeKml", _descriptor7, this);
    _initializerDefineProperty(this, "includeCsv", _descriptor8, this);
    _initializerDefineProperty(this, "includeEsriMapServer", _descriptor9, this);
    _initializerDefineProperty(this, "includeGeoJson", _descriptor0, this);
    _initializerDefineProperty(this, "wmsResourceFormat", _descriptor1, this);
    _initializerDefineProperty(this, "kmlResourceFormat", _descriptor10, this);
    _initializerDefineProperty(this, "csvResourceFormat", _descriptor11, this);
    _initializerDefineProperty(this, "esriMapServerResourceFormat", _descriptor12, this);
    _initializerDefineProperty(this, "geoJsonResourceFormat", _descriptor13, this);
    _initializerDefineProperty(this, "getRecordsTemplate", _descriptor14, this);
  }
}, _descriptor4 = _applyDecoratedDescriptor(_class3.prototype, "flatten", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, "domainSpecification", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, "includeWms", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, "includeKml", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class3.prototype, "includeCsv", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class3.prototype, "includeEsriMapServer", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class3.prototype, "includeGeoJson", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class3.prototype, "wmsResourceFormat", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "\\bwms\\b";
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class3.prototype, "kmlResourceFormat", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "\\bkml\\b";
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class3.prototype, "csvResourceFormat", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "\\bcsv-geo-";
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class3.prototype, "esriMapServerResourceFormat", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "\\besri rest\\b";
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class3.prototype, "geoJsonResourceFormat", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "\\bgeojson\\b";
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class3.prototype, "getRecordsTemplate", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class3)) || _class2);
export { CswCatalogGroupTraits as default };